@let copy = copyObject();

<rt-dialog-body variant="white">
  <div class="dialog-content">
    <div class="avatar-container">
      <div class="icon-container">
        <rt-icon name="person" size="large" colorToken="colorIconOnaccentDefault" />
      </div>

      <div class="checkmark-container">
        <div class="icon-container">
          <rt-icon name="check" colorToken="colorIconOnsuccessDefault" />
        </div>
      </div>
    </div>
    <div class="heading-container">
      <span class="heading"> {{ copy.heading }}</span>
      <span class="subheading" [innerHTML]="copy.subheading"></span>
    </div>

    <div class="buttons-container">
      <rt-button variant="tertiary" (click)="fillOutEmployeeProfile()">
        <rt-icon prefix name="open-in-new" />
        <span>{{
          'tlc.members.member_added_success_dialog.buttons.complete_profile' | translate
        }}</span>
      </rt-button>
      <rt-button variant="tertiary" (click)="startPreonboarding()">
        <rt-icon prefix name="tellent-journeys" />
        <span>{{
          'tlc.members.member_added_success_dialog.buttons.start_preonboarding_journey' | translate
        }}</span>
      </rt-button>
      <rt-button variant="primary" (click)="finishAndClose()">
        <span>{{
          'tlc.members.member_added_success_dialog.buttons.finish_and_close' | translate
        }}</span>
      </rt-button>
    </div>
  </div>
</rt-dialog-body>
